import { all, fork } from 'redux-saga/effects';
import { watchGetCurrentUserProfileSaga } from './sagas/get';
import { watchSaveCurrentUserProfileSaga } from './sagas/save';
import { slice } from './slice';
export function* currentUserProfileRootSaga() {
    yield all([
        fork(watchGetCurrentUserProfileSaga),
        fork(watchSaveCurrentUserProfileSaga)
    ]);
}
export const getCurrentUserProfileState = (state)=>state.currentUserProfile;
export const { start, success } = slice.actions;
export const currentUserProfileReducer = slice.reducer;
